import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getClubsApi } from '../../api/club.api';

export const fetchClubs = createAsyncThunk('clubs/fetchClubs', async (params, thunkAPI) => {
  try {
    const { data } = await getClubsApi(params);
    return { items: data.data, meta: data.meta };
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data?.message || 'خطا در دریافت باشگاه‌ها');
  }
});

const clubSlice = createSlice({
  name: 'clubs',
  initialState: {
    items: [],
    meta: null,
    status: 'idle', // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClubs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchClubs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.items;
        state.meta = action.payload.meta;
      })
      .addCase(fetchClubs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default clubSlice.reducer;


